import React from 'react';
import DonutChart from '../../components/trading/donutchart';
// import CardMenu from '../cardmenu/cardmenu';
import CardMenu from '../../containers/cardmenu/cardmenu';
import { connect } from 'react-redux';
import { getTransactionDetailsListing } from '../../redux/actions/transactiondetails/transactiondetailsaction';
import { bindActionCreators } from 'redux';
import { SimilarSchemeDetails } from '../../redux/actions/schemes/similarschemesaction';
import { SchemeLinePerformationDetails } from '../../redux/actions/schemes/lineperformancecard'
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router'
import labels from '../../utils/constants/labels';
import { Redirect } from 'react-router';
import Skeleton from '@material-ui/lab/Skeleton';
import colors from '../../utils/colors/colors';
import ErrorBoundary from '../../components/Errorhandling/Errorhandle';
const styles = theme => ({
  header: {
    fontSize: 21,
    fontWeight: 600,
    textAlign: "start",
    color: colors.BLACK_PRIMARY
  },
  root: {
    flexGrow: 1,
  },
  container: {
    // marginTop: 395,       
    marginLeft: '2.5%',

  },
  // mobile responsive added by yogitha on 01/06/2021
  desktopResponsive: {
    display: 'block !important',

    [theme.breakpoints.down("900")]: {
      display: 'none !important',
    },

  },
  mobileResponsive: {
    display: 'none !important',
    [theme.breakpoints.down("900")]: {
      display: 'block !important',
      width: '100%',
    }
  },
  returnPaper: {
    paddingBottom: "10px",
    minHeight: "98%",
    boxShadow: "0 0 20px 0 rgba(19, 89, 161, 0.1)",
    [theme.breakpoints.down("900")]: {
      width: '90%',
      marginLeft: '2%',
      borderRadius: '10px !important',
    }
  },
  returnLabel: {
    marginTop: '10%',
    paddingLeft: '10px',
    fontWeight: 'bold',
    color: window.globalConfig.color.BLACK_PRIMARY,
    fontSize: 18,
    [theme.breakpoints.down("900")]: {
      marginTop: '4%',
    },
  },
  cardMenu: {
    marginBottom: "0%",
    marginLeft: "1.8%",
    marginRight: "1.8%",
    // height: 82,
    gridTemplateColumns: "18% 18% 15% 18% 18% 13%",
    alignItems: "baseline",
    // paddingTop: 10,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,

    "& .data1": {
      height: "48px !important",
      padding: 10,
      borderRight: `1px solid ${colors.BORDER}`
    },
    "& .data2": {
      // height: "0px !important",
      padding: 10,
      borderRight: `1px solid ${colors.BORDER}`
    },
    "& .data3": {
      padding: 10,
      // height: "0px !important",
      borderRight: `1px solid ${colors.BORDER}`
    },
    "& .data4": {
      padding: 10,
      // height: "0px !important",
      borderRight: `1px solid ${colors.BORDER}`
    },
    "& .data5": {
      padding: 10,
      // height: "0px !important",
      borderRight: `1px solid ${colors.BORDER}`
    },

  },
  cardSpareaterLine: {
    height: 0.5,
    width: "100%",
    backgroundColor: window.globalConfig.color.PRIMARY_BORDER
    , marginTop: "2%"
  },
  carouselCardResponsive: {
    backgroundColor: window.globalConfig.color.ZERO_BACKGROUND,
    paddingTop: 40,
    paddingLeft: "0px",
    paddingRight: "15px",
    [theme.breakpoints.down("900")]: {
      paddingBottom: 20,
      paddingTop: 20,
    },
  },
  topHoldingCard: {
    height: '83%',
    width: '90%',
    margin: '8% 2% 0% 2%',
    boxShadow: 'rgb(19 89 161 / 10%) 0px 0px 20px 0px',
    [theme.breakpoints.down("900")]: {
      margin: '4% 2% 0% 2%',
    },
    [theme.breakpoints.down("900")]: {
      margin: '8% 2% 0% 2%',
    },
  },
  square: {
    // color: theme.palette.getContrastText(deepOrange[500]),
    // backgroundColor: deepOrange[500],
    height: "78px",
    width: "55px",
    borderRadius: "7px",
  },
  // topHoldingCardResponsive:{
  // maxHeight:'433px',
  // },
  donutChartResponsive: {
    height: "100%",
    margin: '4% 0% 13% 4%',
    width: '92%',
    boxShadow: "0 0 20px 0 rgba(19, 89, 161, 0.1)"
  },
  allocationCard: {
    height: '83%', overflowY: 'scroll', overflowX: 'hidden',
    width: '92%',
    margin: '8% 4% 13% 4%',
    boxShadow: 'rgb(19 89 161 / 10%) 0px 0px 20px 0px',
    [theme.breakpoints.down("sm")]: {
      height: '83%', overflowY: 'scroll', overflowX: 'hidden',
      width: '90%',
      margin: '3% 0% 13% -7%',
      boxShadow: 'rgb(19 89 161 / 10%) 0px 0px 20px 0px',
    },
    [theme.breakpoints.down("xs")]: {
      height: '83%', overflowY: 'scroll', overflowX: 'hidden',
      width: '92%',
      margin: '8% 4% 13% 4%',
      boxShadow: 'rgb(19 89 161 / 10%) 0px 0px 20px 0px',
    },
  },

})
// let LineChartData = []
class SchemeLoader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    const { classes } = this.props;

    try {
      return <React.Fragment>

        <ErrorBoundary>
          <>
            <div style={{ backgroundColor: colors.PRIMARY, display: "grid", gridTemplateColumns: "9.5% 81% 9.5%" }}>
              <div></div>
              <div>
                <div style={{ display: "grid", gridTemplateColumns: "50% 48%" }}>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 10, padding: "15px 0px" }}>
                    <Skeleton className={classes.square}></Skeleton>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

                      <Skeleton style={{ width: 200, height: 34 }}></Skeleton>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, color: colors.WHITE, fontSize: 14 }}>
                        <span>{<Skeleton style={{ width: 200, height: 34 }}></Skeleton>}  </span>
                        <span style={{ color: "#4275aa" }}>|</span>
                        <span style={{ color: "#c6d3e1" }}>  <Skeleton style={{ width: 100, height: 34 }}></Skeleton> </span>
                      </div>
                    </div>

                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-end", padding: "15px 0px" }} onScroll>
                    <span style={{ color: "white", fontWeight: "bold", fontSize: 24 }}>
                      <Skeleton style={{ width: 400, height: 34 }} ></Skeleton>
                    </span>
                    <span style={{ fontSize: 14, color: "#c6d3e1" }}>{<Skeleton style={{ width: 400, height: 34 }}></Skeleton>}</span>
                  </div>
                </div>


                <CardMenu
                  className="cardmenu"
                  style={classes.cardMenu}
                  // flag="1"
                  // data={
                  //   this.state.cardData
                  // }

                  loader={true}
                />
              </div>
              <div></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "11% 78% 10%", marginBottom: "3%" }}>
              <div></div>
              <div style={{ gap: 15, display: "flex", flexDirection: "column" }}>
                <div style={{ boxShadow: "rgb(19 89 161 / 10%) 0px 13px 20px 0px", height: "35%", borderBottomLeftRadius: 10, borderBottomRightRadius: 10, width: '100%', overflowY: "hidden", overflowX: "hidden", borderTop: `1px solid ${colors.BORDER}` }}>
                  <div style={{ display: "grid", gridTemplateColumns: "66% 34%" }}>
                    <div style={{ padding: "12px 15px" }}>
                      <div className={classes.header}>Performance</div>
                      <Skeleton style={{ height: 500, marginTop: -110 }}></Skeleton>
                    </div>

                    <div style={{ overflow: "hidden" }}>

                      <Skeleton style={{ height: 612, marginTop: -166 }}></Skeleton>
                    </div>
                  </div>

                </div>
                <div style={{ boxShadow: "0 0 20px 0 rgba(19, 89, 161, 0.1)", borderRadius: 10, overflowY: "auto", overflowX: "hidden" }}>
                  <div className={classes.header} style={{ paddingLeft: 15, paddingTop: 12 }}> Returns</div>
                  {/* <Tables returns={this.state.returns} /> */}
                  <div style={{ margin: 10 }}>
                    <Skeleton style={{ height: 52, width: "100%" }}></Skeleton>
                    <Skeleton style={{ height: 52, width: "100%" }}></Skeleton>
                    <Skeleton style={{ height: 52, width: "100%" }}></Skeleton>
                  </div>
                  {/* <Chip className="showmore" onClick={() => { this.setState({ showmore: this.state.showmore == false ? true : false }) }} label={this.state.showmore == false ? lable.tranactionSchemesDetails.SimilarView : lable.tranactionSchemesDetails.SimilarHide}></Chip>
                  {this.state.showmore && <div style={{ backgroundColor: "rgb(239 239 239)", paddingTop: 40, paddingLeft: "10px", paddingRight: "10px", paddingBottom: "40px", borderBottomLeftRadius: 10, borderBottomRightRadius: 10, margin: 1 }}>
                    <Carousel data={this.state.similarSchemes} onClick={this.onClickSchemes} />
                  </div>} */}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "49% 49%", gap: 20 }}>
                  <div style={{ boxShadow: "0 0 20px 0 rgba(19, 89, 161, 0.1)", borderRadius: 10, overflowY: "auto", overflowX: "hidden" }}>
                    <div className={classes.header} style={{ paddingLeft: 15, paddingTop: 12 }}> Top 10 Holdings</div>
                    <Skeleton style={{ height: 450,margin:10}}></Skeleton>
                  </div>
                  <div style={{ boxShadow: "0 0 20px 0 rgba(19, 89, 161, 0.1)", borderRadius: 10, overflowY: "auto", overflowX: "hidden" }}>
                    <DonutChart isTransactionDetailsLoading={true} />
                  </div>
                </div>

              </div>
              <div></div>

            </div></>


        </ErrorBoundary>

      </React.Fragment >
    } catch (err) {
      // console.log(err)
      return <Redirect to={labels.Path.NotFound} />
    }
  }

}
const mapStateToProps = state => {

  return {
    // logindetails: state.Login.logindetails,
    // userDetails:
    //   state.ProfileDetails.AllProfileDetails.length != 0
    //     ? state.ProfileDetails.AllProfileDetails.mainDetails != "NA"
    //       ? state.ProfileDetails.AllProfileDetails.mainDetails
    //       : []
    //     : [],
    // Kycmessage: state.Kyc.Kycmessage,
    // AssetData: state.TransactionDetails.transactionDetailsList.length == 0 ? [] : state.TransactionDetails.transactionDetailsList.mF_AssetAllocation != null ? state.TransactionDetails.transactionDetailsList.mF_AssetAllocation : [],
    // SchemeList: state.Dropdown.dropdowndetails.length == 0 ? [] : state.Dropdown.dropdowndetails.scheme.filter(value => value.Ranking < 11),
    // Schemedetails: state.TransactionDetails.transactionDetailsList.schemeDetail,
    // topholding: state.TransactionDetails.transactionDetailsList.topHoldings,
    // mF_FundDetail: state.TransactionDetails.transactionDetailsList.mF_FundDetail,
    // Performance: state.TransactionDetails.transactionDetailsList.historicalNAV != null && state.TransactionDetails.transactionDetailsList.historicalNAV != undefined ? state.TransactionDetails.transactionDetailsList.historicalNAV : [],
    // LineChart: state.TransactionDetails.transactionDetailsList.mF_OtherInformations != null && state.TransactionDetails.transactionDetailsList.mF_OtherInformations != undefined ? state.TransactionDetails.transactionDetailsList.mF_OtherInformations : [],
    // returns: state.TransactionDetails.transactionDetailsList == null ? [] : state.TransactionDetails.transactionDetailsList.mfReturns == null ? [] : state.TransactionDetails.transactionDetailsList.mfReturns.slice(0, 2)
    // , cardmenu: [{ "firstName": "Min SIP Amount", "lastName": state.TransactionDetails.transactionDetailsList.length != 0 && state.TransactionDetails.transactionDetailsList.mF_FundDetail != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.minSIPAmount != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.minSIPAmount : 0 : 0 }, { "firstName": "Fund Started", "lastName": state.TransactionDetails.transactionDetailsList.length != 0 && state.TransactionDetails.transactionDetailsList.mF_FundDetail != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail._InceptDate != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail._InceptDate : 0 : 0 }, { "firstName": "Expense Ratio", "lastName": state.TransactionDetails.transactionDetailsList.length != 0 && state.TransactionDetails.transactionDetailsList.mF_FundDetail != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.expenseRatio != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.expenseRatio : 0 : 0 }, { "firstName": "Fund Manager", "lastName": state.TransactionDetails.transactionDetailsList.length != 0 ? state.TransactionDetails.transactionDetailsList.mF_FundDetail != null && state.TransactionDetails.transactionDetailsList.mF_FundDetail.fundManager != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.fundManager : 0 : 0 }, { "firstName": "Fund Size (Rs. in CR)", "lastName": state.TransactionDetails.transactionDetailsList.length != 0 && state.TransactionDetails.transactionDetailsList.mF_FundDetail != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.fundSize != null ? state.TransactionDetails.transactionDetailsList.mF_FundDetail.fundSize : 0 : 0 }, { 'firstName': "CAGR (3 yrs)", "lastName": state.TransactionDetails.transactionDetailsList.length != 0 && state.TransactionDetails.transactionDetailsList.schemeDetail != null ? state.TransactionDetails.transactionDetailsList.schemeDetail._threeYearReturn : 0 }]
    // , similarschemes: state.SchemeDetails.similarschemes
    // , isNetworkLow: state.SchemeDetails.isNetworkLow,
    // isTransactionDetailsLoading: state.TransactionDetails.isTransactionDetailsLoading,
    // filter: state.Dropdown.dropdowndetails.length == 0 ? [] : state.Dropdown.dropdowndetails.scheme,
    // lineChartPerfomance: state.LinePerformaceChart.linePerformance != undefined && state.LinePerformaceChart.linePerformance != 0 ? state.LinePerformaceChart.linePerformance : [],
    // sixMonthPerformance: state.LinePerformaceChart.sixMonthPerformance != undefined && state.LinePerformaceChart.sixMonthPerformance != 0 ? state.LinePerformaceChart.sixMonthPerformance : [],
    // threeYearPerformance: state.LinePerformaceChart.threeYearPerformance != undefined && state.LinePerformaceChart.threeYearPerformance != 0 ? state.LinePerformaceChart.threeYearPerformance : [],
    // maxYeadPerformance: state.LinePerformaceChart.maxYeadPerformance != undefined && state.LinePerformaceChart.maxYeadPerformance != 0 ? state.LinePerformaceChart.maxYeadPerformance : [],
  }
}
const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getTransactionDetailsListing, 
    // getKYCActionDetails, 
    SimilarSchemeDetails, SchemeLinePerformationDetails }, dispatch)
}
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(SchemeLoader)));
